<template>
  <div v-if="getSelectedItems.length > 0" class="cancel-filter">
    <h6 class="cancel-filter__title">{{ result.messages.choose }}</h6>
    <div v-for="item in getSelectedItems" class="cancel-filter__items">
      <!-- view for all checkbox-->
      <span v-if="item.VALUE" class="cancel-filter__item" @click="handlerDeleteElement(item)">
        <svg><use xlink:href="#svg-close"></use></svg>
        {{ item.printRange || item.VALUE }}
      </span>

      <!-- view for range price-->
      <span v-else class="cancel-filter__item" @click="handlerDeleteRange(item)">
        <svg><use xlink:href="#svg-close"></use></svg>
        {{ item.printRange }}
      </span>
    </div>
    <a
      v-if="result.actions && result.actions.resetFilter"
      :href="result.actions.resetFilter.link"
      class="cancel-filter__reset"
      @click.prevent="$emit('resetFilter', result.actions.resetFilter.link)"
    >
      {{ result.actions.resetFilter.text }}
    </a>
    <hr class="catalog-filter__line" />
  </div>
</template>

<script>
export default {
  name: 'CancelFilter',
  props: {
    result: {
      type: Object,
    },
  },
  computed: {
    getSelectedItems() {
      const obj = this.result.ITEMS;
      const arr = [];

      for (const key in obj) {
        const subObj = obj[key].VALUES;
        if (key === '183') {
          /** get string for price range* */
          const range = {};
          const newObj = {
            ...obj[key],
          };
          for (const i in subObj) {
            if (subObj[i].HTML_VALUE) {
              range[i] = subObj[i].HTML_VALUE;
            }
          }
          if (range.MIN && range.MAX) {
            newObj.printRange = `от(нужен текст) ${range.MIN} до(нужен текст) ${range.MAX}`;
          } else if (range.MIN) {
            newObj.printRange = `от(нужен текст) ${range.MIN}`;
          } else if (range.MAX) {
            newObj.printRange = `до(нужен текст) ${range.MAX}`;
          }
          if (newObj.printRange) {
            arr.push(newObj);
          }
        } else if (obj[key].VALUES) {
          /** get all checkbox * */
          for (const i in subObj) {
            if (subObj[i].CHECKED) {
              arr.push(subObj[i]);
            }
          }
        }
      }
      return arr;
    },
  },
  methods: {
    handlerDeleteElement(item) {
      const el = this.$parent.$el.querySelector(`[name="${item.CONTROL_NAME}"]`);
      el.checked = false;
      this.$emit('handlerChangeData');
    },
    handlerDeleteRange(item) {
      const items = item.VALUES;
      for (const el in items) {
        const input = this.$parent.$el.querySelector(`[name="${items[el].CONTROL_NAME}"]`);
        input.value = '';
      }
      this.$emit('handlerChangeData');
    },
  },
};
</script>

<style lang="scss">
.cancel-filter {
  color: #191918;
  &__title {
    font-weight: 500;
    font-size: rem(12);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 16px;
    @include point-md {
      font-size: rem(14);
    }
  }
  &__items {
    display: flex;
    flex-wrap: wrap;
  }
  &__item {
    display: flex;
    align-items: center;
    margin: 0 17px 16px 0;
    font-size: rem(14);
    @include point-md {
      font-size: rem(16);
    }
    &:hover {
      cursor: pointer;
    }
    svg {
      width: 12px;
      height: 12px;
      margin-right: 5px;
    }
  }
  &__reset {
    cursor: pointer;
    font-weight: 500;
    font-size: rem(10);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    text-decoration: underline;
    text-decoration-style: dashed;
    @include point-md {
      font-size: rem(12);
    }
  }
}
</style>
